import { render } from "./PlayerCardDetail.vue?vue&type=template&id=41b0ad33&scoped=true"
import script from "./PlayerCardDetail.vue?vue&type=script&lang=js"
export * from "./PlayerCardDetail.vue?vue&type=script&lang=js"

import "./PlayerCardDetail.vue?vue&type=style&index=0&id=41b0ad33&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b0ad33"]])

export default __exports__